import { Selectable } from '@app/shared/models/selectable.interface';

export class SensorNodeChangeHistory {
  public oldX: number;
  public oldY: number;
  public oldIsChanged: boolean;

  constructor(public node: Selectable) {
    if (!this.node) {
      return;
    }
    this.oldX = node.x;
    this.oldY = node.y;
    this.oldIsChanged = node.isChanged;
  }

  public undo(): void {
    if (!this.node) {
      return;
    }
    this.node.x = this.oldX;
    this.node.y = this.oldY;
    this.node.isChanged = this.oldIsChanged;
  }
}
